/** biome-ignore-all lint/nursery/useExplicitType: Zod schema inference */
import { z } from 'zod';

export const challengeProgressSchema = z.object({
  challengeId: z.number(),
  level: z.number(),
  passed: z.number(),
  failed: z.number(),
  nextReviewAt: z.number(),
});

export type IChallengeProgress = z.infer<typeof challengeProgressSchema>;
